/**
 * customerDefinedAlarmConfiguration模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const customerDefinedAlarmConfiguration = {
  //客户报警规则分页
  customAlertRulePage(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/customAlertRulePage`,params);
  },
  //默认报警规则分页
  defaultAlertRulePage(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/defaultAlertRulePage`,params);
  },
  //编辑自定义报警规则
  updateCustomAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/updateCustomAlertRule`,params);
  },
  //编辑默认报警规则
  updateDefaultAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/updateDefaultAlertRule`,params);
  },
  //创建报警规则
  createDefaultAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/createDefaultAlertRule`,params);
  },
  //根据ID查询报警规则
  selectCompanyMonitoritemVariablesById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/selectCompanyMonitoritemVariablesById`,param);
  },
  // 通用SOP列表
  defaultSopList() {
    return $http.get(`${global.API_URL}/sme/agentverse/sop/list`);
  },
  // 通用SOP处理
  defaultSop(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/sop/defaultSop`,params);
  },
  // 自定义SOP处理
  customerSop(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/sop/customerSop`,params);
  },
  // SOP详情
  getSopDetail(id, companyId) {
    return $http.get(`${global.API_URL}/sme/agentverse/sop/detail?customerMetricId=` + id + '&companyId=' + companyId);
  },
  // SOP识别
  sopIdentify(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/sop/identify`,params);
  },
  // SOP提交
  sopConfirm(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/sop/emailTemplate/confirm`,params);
  },
  // 更改AI监控告警状态
  changAiStatus(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/changAiStatus/${params.id}?status=` + params.status);
  },
  // 查询人工接管状态
  getAiStatus() {
    return $http.get(`${global.API_URL}/sme/manualTakeover/status`);
  },
  // 更新人工接管状态
  updateAiStatus(enabled) {
    return $http.post(`${global.API_URL}/sme/manualTakeover/update?enabled=` + enabled);
  },
  // 开启关闭邮件状态
  updateEmailStatus(id, status) {
    return $http.put(`${global.API_URL}/sme/agentverse/sop/changeEmailStatus/` + id + '/' + status);
  }
}

export default customerDefinedAlarmConfiguration;



// WEBPACK FOOTER //
// ./src/api/customerDefinedAlarmConfiguration.js